
import { Component, Vue, Watch } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import {
  fuzzyQuerySupplier,
} from "@/api/package";

import {
  getOtherInfo,
  downloadOtherInfo,
  uploadOtherInfo,
  deleteOtherInfo,
} from "@/api/package";
import LabelInfo
  from "@/views-oms/package-info-management/otherInfoManagement/components/edit/labelInfo.vue";


@Component({
  name: "OtherInfoManagement",
  components: {
    LabelInfo,
    Pagination,
    EditForm: () => import("./components/edit/index.vue"),
  },
})
export default class extends Vue {
  private listLoading = true;
  private showEdit = false;
  private showLabelInfoEdit = false;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [] as any[],
  };
  public listParam = {
    brandId: null,
    inquiryRefNumber: null,
    sku: null,
    hqProductName: null,
    supplier: null,
  };
  public downloadLoading = false;
  public searchForm = [
    {
      label: "客人简称或编号",
      prop: "customerAbbr",
      key: "customerAbbr",
      type: "input",
      value: "",
      placeholder: "",
      readonly: true,
    },
    {
      label: "当前品牌",
      prop: "customerBrand",
      key: "customerBrand",
      type: "input",
      value: "",
      readonly: true,
    },
    {
      label: "销售员",
      prop: "seller",
      key: "seller",
      type: "input",
      options: [],
      value: "",
      placeholder: "销售员",
      readonly: true,
    },
    {
      label: "销售助理",
      prop: "saleAssistant",
      key: "saleAssistant",
      type: "input",
      value: "",
      readonly: true,
    },
    {
      label: "识别号码",
      prop: "inquiryRefNumber",
      key: "inquiryRefNumber",
      type: "input",
      value: "",
      placeholder: "请输入识别号码",
    },
    {
      label: "SKU",
      prop: "sku",
      key: "sku",
      type: "input",
      value: "",
      placeholder: "请输入SKU",
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      type: "input",
      value: "",
      placeholder: "",
    },
    {
      label: "供应商",
      prop: "supplier",
      key: "supplier",
      type: "select",
      value: "",
      placeholder: "",
      remote_method: this.getSuppliersList,
      remote: true,
      clearable: true,
      options: [],
      resetKey: { label: "abbr", value: "id" },
    },
  ];
  public tableCol = [
    {
      label: "S/N",
      prop: "sn",
      key: "sn",
      show: true,
      fixed: true,
      disabled: false
    },
    {
      label: "识别号码",
      prop: "inquiryRefNumber",
      key: "inquiryRefNumber",
      show: true,
      disabled: false,
    },
    {
      label: "识别号码类型",
      prop: "inquiryRefType",
      key: "inquiryRefType",
      show: true,
      disabled: false,
    },
    {
      label: "华强品名",
      prop: "hqProductName",
      key: "hqProductName",
      show: true,
      disabled: false,
    },
    {
      label: "供应商简称",
      prop: "supplier",
      key: "supplier",
      show: true,
      disabled: false,
    },
    {
      label: "尼龙袋",
      prop: "nylon",
      key: "nylon",
      show: true,
      disabled: false,
    },
    {
      label: "内盒",
      prop: "innerBox",
      key: "innerBox",
      show: true,
      disabled: false,
    },
    {
      label: "外箱",
      prop: "outerBox",
      key: "outerBox",
      show: true,
      disabled: false,
    },
    {
      label: "托盘",
      prop: "pallet",
      key: "pallet",
      show: true,
      disabled: false,
    },
    {
      label: "激光—客人商标",
      prop: "customerLogo",
      key: "customerLogo",
      show: true,
      disabled: false,
    },
    {
      label: "激光—客人供应商代码",
      prop: "customerSupplierCode",
      key: "customerSupplierCode",
      show: true,
      disabled: false,
    },
    {
      label: "激光—其他信息",
      prop: "laserOtherInfo",
      key: "laserOtherInfo",
      show: true,
      disabled: false,
    },
    {
      label: "内盒贴标—产品名称",
      prop: "productName",
      key: "productName",
      show: true,
      disabled: false,
    },
    {
      label: "内盒贴标—OE号码",
      prop: "oeNumber",
      key: "oeNumber",
      show: true,
      disabled: false,
    },
    {
      label: "内盒贴标—车型",
      prop: "carApplication",
      key: "carApplication",
      show: true,
      disabled: false,
    },
    {
      label: "内盒贴标—条形码",
      prop: "barCode",
      key: "barCode",
      show: true,
      disabled: false,
    },
    {
      label: "内盒贴标—QR码",
      prop: "qrCode",
      key: "qrCode",
      show: true,
      disabled: false,
    },
    {
      label: "内盒贴标—其他信息",
      prop: "innerBoxOtherInfo",
      key: "innerBoxOtherInfo",
      show: true,
      disabled: false,
    },
    {
      label: "贴标资料",
      prop: "labelInfoCounts",
      key: "labelInfoCounts",
      show: true,
      disabled: false,
      type: "link",
    },
    {
      label: "操作",
      prop: "actions",
      key: "actions",
      type: "actions",
      options: [
        {
          name: "编辑",
          code: "",
          click: "handleEdit",
        },
        {
          name: "删除",
          code: "",
          click: "handleDelete",
          type: "delete",
        },
      ],
      show: true,
      disabled: false,
      width: 300,
    },
  ] as any;
  private customerInfo = {} as any;
  private customerId = "" as any;
  private brandId = "" as any;
  created() {
    this.customerInfo =  JSON.parse(decodeURIComponent(this.$route.query.item as string));
    this.customerId = this.customerInfo.customerId;
    this.searchForm[0].value = this.customerInfo.customerAbbr;
    this.searchForm[1].value = this.customerInfo.brand;
    this.searchForm[2].value = this.customerInfo.seller;
    this.searchForm[3].value = this.customerInfo.saleAssistant;
    this.brandId = this.customerInfo.brandId;
    this.init();
  }

  activated() {
    this.init();
  }

  private init() {
    this.getSuppliersList();
    this.getList();
  }

  private async getSuppliersList(name = "") {
    const res: any = await this.getSuppliers(name);
    this.searchForm[7].options = res;
  }

  private async getSuppliers(name = "") {
    const res: any = await fuzzyQuerySupplier(this.brandId,name);
    return res;
  }

  public loading: Boolean = false;
  private async getList() {
    this.loading = true;
    this.listParam.brandId = this.brandId;
    const params = {
      ...this.listParam,
      pageNumber: this.table.pageNumber,
      pageSize: this.table.pageSize,
    };
    this.listLoading = false;
    const { total, list }: any = await getOtherInfo(params);
    this.table.total = +total;
    this.table.list = list;
    this.loading = false;
    setTimeout(() => {
      this.listLoading = false;
    }, 0.3 * 1000);
  }

  private handleSuccess() {
    this.showEdit = false;
    this.getList();
  }


  public handleCommand(command) {
    this[command]();
  }

  private cover;

  private uploadWithUpdate() {
    this.cover = false;
    this.$refs['uploadNo']["$refs"]['upload-inner'].handleClick()
  }

  private uploadWithCover() {
    this.cover = true;
    this.$refs['uploadNo']["$refs"]['upload-inner'].handleClick()
  }


  public selectedItem = {} as any;

  // 编辑
  public async handleEdit(scope) {
    this.selectedItem = scope.row;
    this.showEdit = true;
  }

  // 上传维护
  private async handleUpload(file: any) {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    let formData = new FormData();
    formData.append("file", file.file);
    formData.append("customerId", this.customerId);
    formData.append("cover", this.cover);
    formData.append("autoIncrementSn", 'false');
    await uploadOtherInfo(formData)
      .then(() => {
        loading.close();
        this.confirmSuccess();
      })
      .catch((err) => {
        loading.close();
        console.error(err)
      });
  }

  //下载
  private async download() {
    this.downloadLoading = true;
    try {
      await downloadOtherInfo({
        brandId: this.brandId
      });
    } catch (err) {
      console.error(err);
    } finally {
      this.downloadLoading = false;
    }
  }

  private async deleteMorePackageInfo() {
    if (!this.selectedRows.length) {
      this.$notify.error("请选择要删除的数据");
      return;
    }
    const ids = this.selectedRows.map((item) => item.id);
    this.$confirm("确定删除吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        this.deletePackageInfo(ids);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  //  删除
  public handleDelete(scope) {
    this.deletePackageInfo([scope.row.id]);
  }

  private async deletePackageInfo(data) {
    await deleteOtherInfo(data)
      .then((res) => {
        this.confirmSuccess();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  public querySearch(data) {
    this.listParam = {...data};
    this.table.pageNumber = 1;
    this.getList();
  }

  private curId = '';

  private linkClick(scope) {
    this.curId = scope.row.id;
    this.showLabelInfoEdit = true;
  }

  private confirmSuccess() {
    (this.$refs.table as any).$refs.table.clearSelection();
    this.$notify({
      title: "成功",
      message: "操作成功",
      type: "success",
      duration: 2000,
    });
    this.getList();
  }

  private selectedRows: any[] = [];

  private onSelectionChange(rows: any[]) {
    this.selectedRows = rows;
  }

  private async handleEditLabelInfoSuccess() {
    this.showLabelInfoEdit = false;
    await this.getList();
  }
}
